import {
  RESET_OBJ,
  RESET_STATUS,
  RESET_CONSUMER_OBJ,
  RESET_CONSUMER_STATUS,
  API_ERROR,
  GET_MESSAGES,
  SET_MESSAGES,
  GET_MESSAGE,
  SET_MESSAGE,
  SEND_MESSAGE,
  SENT_MESSAGE,
  CLOSE_CHAT,
  CLOSED_CHAT,
  TABULATE_CHAT,
  TABULATE_CHAT_TICKET,
  TABULATED_CHAT,
  DISABLE_CHAT,
  DISABLED_CHAT,
  GET_CONSUMER_CONVERSATIONS,
  SET_CONSUMER_CONVERSATIONS,
  GET_CONSUMER_MESSAGES,
  SET_CONSUMER_MESSAGES,
  START_OBSERVER,
  STARTED_OBSERVER,
  GET_CONSUMER_ERROR,
  SEND_INACTIVITY_MSG,
  SENT_INACTIVITY_MSG,
  REMOVE_MESSAGE,
  UPDATE_UNREAD_MSG,
  UPLOAD_FILE,
  UPLOADED_FILE,
  JOIN_CONVERSATION,
  JOINED_CONVERSATION,
  GET_TABS_CHAT,
  SET_TABS_CHAT,
  SAVE_MESSAGE,
  SAVE_SCROLL,
  REMOVE_SCROLL_MESSAGE,
  GET_SKILLS_ATTENDANCE,
  SET_SKILLS_ATTENDANCE,
  CREATE_ATTENDANCE,
  CREATED_ATTENDANCE,
  CREATE_COMMENTARY_SUCCESS,
  CREATE_COMMENTARY_FAILURE,
  CREATE_COMMENTARY,
  DELETE_COMMENTARY_FAILURE,
  DELETE_COMMENTARY_SUCCESS,
  DELETE_COMMENTARY,
  SET_AI_MESSAGE,
} from "./actionTypes";

const initialState = {
  messageOperator: {},
  messageConsumer: {},
  createAttendance: {
    data: [],
    status: {
      get_skills_attendance: {},
      create_attendance: {},
    },
  },
  commentary: {
    success: false,
    error: false,
    loading: false,
  },
  deleteCommentary: {
    success: false,
    error: false,
    loading: false,
  },
};

const Operator = (state = initialState, action) => {
  switch (action.type) {
    case RESET_OBJ:
      state = initialState;
      break;
    case API_ERROR:
      state = {
        ...state,
        messageOperator: {
          ...state.messageOperator,
          status: {
            ...state.messageOperator.status,
            [action.payload.action]: {
              error: {
                status: true,
                message: action.payload.message,
              },
              loading: false,
              success: false,
            },
          },
        },
      };
      break;
    case GET_CONSUMER_ERROR:
      state = {
        ...state,
        messageConsumer: {
          ...state.messageConsumer,
          status: {
            ...state.messageConsumer.status,
            [action.payload.action]: {
              error: {
                status: true,
                message: action.payload.message,
              },
              loading: false,
              success: false,
            },
          },
        },
      };
      break;
    case RESET_STATUS:
      state = {
        ...state,
        messageOperator: {
          ...state.messageOperator,
          status: {
            ...state.messageOperator.status,
            [action.payload]: null,
          },
        },
      };
      break;
    case RESET_CONSUMER_OBJ:
      state = {
        ...state,
        messageConsumer: {},
      };
      break;
    case RESET_CONSUMER_STATUS:
      state = {
        ...state,
        messageConsumer: {
          ...state.messageConsumer,
          status: {
            ...state.messageConsumer.status,
            [action.payload]: null,
          },
        },
      };
      break;
    case CLOSE_CHAT:
      state = {
        ...state,
        messageOperator: {
          ...state.messageOperator,
          data: action.payload,
          status: {
            ...state.messageOperator.status,
            close_chat: {
              error: false,
              loading: true,
              success: false,
            },
          },
        },
      };
      break;
    case CLOSED_CHAT:
      state = {
        ...state,
        messageOperator: {
          ...state.messageOperator,
          data: action.payload,
          status: {
            ...state.messageOperator.status,
            close_chat: {
              error: false,
              loading: false,
              success: {
                status: true,
                chatId: action.payload.chatId,
                tabId: action.payload.tabId,
                chatStatus: action.payload.status,
              },
            },
          },
        },
      };
      break;
    case GET_TABS_CHAT:
      state = {
        ...state,
        messageOperator: {
          ...state.messageOperator,
          data: {
            ...action.payload,
            form: {
              tabs: [],
            },
          },
          status: {
            ...state.messageOperator.status,
            get_tabs_chat: {
              error: false,
              loading: true,
              success: false,
            },
          },
        },
      };
      break;
    case SET_TABS_CHAT:
      state = {
        ...state,
        messageOperator: {
          ...state.messageOperator,
          data: action.payload,
          status: {
            ...state.messageOperator.status,
            get_tabs_chat: {
              error: false,
              loading: false,
              success: true,
            },
          },
        },
      };
      break;
    case TABULATE_CHAT:
      state = {
        ...state,
        messageOperator: {
          ...state.messageOperator,
          data: action.payload,
          status: {
            ...state.messageOperator.status,
            tabulate_chat: {
              error: false,
              loading: true,
              success: false,
            },
          },
        },
      };
      break;
    case TABULATE_CHAT_TICKET:
      state = {
        ...state,
        messageOperator: {
          ...state.messageOperator,
          data: action.payload,
          status: {
            ...state.messageOperator.status,
            tabulate_chat_ticket: {
              error: false,
              loading: true,
              success: false,
            },
          },
        },
      };
      break;
    case TABULATED_CHAT:
      state = {
        ...state,
        messageOperator: {
          ...state.messageOperator,
          data: action.payload,
          status: {
            ...state.messageOperator.status,
            tabulate_chat: {
              error: false,
              loading: false,
              success: {
                message: action.payload.message,
                chatId: action.payload.chatId,
                tabId: action.payload.tabId,
                infoTab: action?.payload?.infoTab ?? false,
              },
            },
          },
        },
      };
      break;
    case DISABLE_CHAT:
      state = {
        ...state,
        messageOperator: {
          ...state.messageOperator,
          data: action.payload,
          status: {
            ...state.messageOperator.status,
            disable_chat: {
              error: false,
              loading: true,
              success: false,
            },
          },
        },
      };
      break;
    case DISABLED_CHAT:
      state = {
        ...state,
        messageOperator: {
          ...state.messageOperator,
          data: action.payload,
          status: {
            ...state.messageOperator.status,
            disable_chat: {
              error: false,
              loading: false,
              success: {
                status: true,
                chatId: action.payload.chatId,
                chatStatus: action.payload.status,
              },
            },
          },
        },
      };
      break;
    case SEND_INACTIVITY_MSG:
      state = {
        ...state,
        messageOperator: {
          ...state.messageOperator,
          data: action.payload,
          status: {
            ...state.messageOperator.status,
            agent_inactivity: {
              error: false,
              loading: true,
              success: false,
            },
          },
        },
      };
      break;
    case SENT_INACTIVITY_MSG:
      state = {
        ...state,
        messageOperator: {
          ...state.messageOperator,
          data: action.payload,
          status: {
            ...state.messageOperator.status,
            agent_inactivity: {
              error: false,
              loading: false,
              success: {
                status: true,
                chatId: action.payload.chatId,
                chatStatus: action.payload.status,
              },
            },
          },
        },
      };
      break;
    case GET_MESSAGES:
      state = {
        ...state,
        messageOperator: {
          ...state.messageOperator,
          data: action.payload,
          status: {
            ...state.messageOperator.status,
            get_messages: {
              error: false,
              loading: true,
              success: false,
            },
          },
        },
      };
      break;
    case GET_CONSUMER_CONVERSATIONS:
      state = {
        ...state,
        messageConsumer: {
          ...state.messageConsumer,
          data: action.payload,
          status: {
            ...state.messageConsumer.status,
            get_conversations: {
              error: false,
              loading: true,
              success: false,
            },
          },
        },
      };
      break;
    case SET_CONSUMER_CONVERSATIONS:
      state = {
        ...state,
        messageConsumer: {
          ...state.messageConsumer,
          data: null,
          chats: {
            data: {
              ...(state.messageConsumer.chats
                ? state.messageConsumer.chats.data
                : null),
              [action.payload.id]: action.payload.data.data,
            },
          },
          status: {
            ...state.messageConsumer.status,
            get_conversations: {
              error: false,
              loading: false,
              success: true,
            },
          },
        },
      };
      break;
    case GET_CONSUMER_MESSAGES:
      state = {
        ...state,
        messageConsumer: {
          ...state.messageConsumer,
          data: action.payload,
          status: {
            ...state.messageConsumer.status,
            get_messages: {
              error: false,
              loading: true,
              success: false,
            },
          },
        },
      };
      break;
    case SET_CONSUMER_MESSAGES: {
      let messageOperator = state.messageOperator;
      let chats = messageOperator.chats;
      let data = chats.data;

      const chatMessages =
        state.messageConsumer.messages &&
        action.payload.id &&
        state.messageConsumer.messages[action.payload.id]
          ? action.payload.data.data.messages.length > 0
            ? [
                ...action.payload.data.data.messages.reverse(),
                ...state.messageConsumer.messages[action.payload.id],
              ]
            : [
                ...state.messageConsumer.messages[action.payload.id],
                { type: "eof" },
              ]
          : Array.isArray(action.payload.data.data.messages) &&
            action.payload.data.data.messages.reverse();

      const chatPos = state?.messageOperator?.chats?.data?.findIndex(
        (e) => e.conversationId === action.payload.id
      );
      if (chatPos >= 0) {
        const lenghtOfChatMessages = chatMessages.length - 1;
        const chatMessagesReversed = [...chatMessages].reverse();
        const indexOfLastMessage = lenghtOfChatMessages - chatMessagesReversed.findIndex(
          (msg) => msg.by !== 'ai',
        );
        const lastMessage = {
          by: chatMessages[indexOfLastMessage]?.by,
          time: chatMessages[indexOfLastMessage]?.sentTime,
          text: chatMessages[indexOfLastMessage]?.text,
          location: chatMessages[indexOfLastMessage]?.location,
          files: chatMessages[indexOfLastMessage]?.files
            ? {
                fileName: chatMessages[indexOfLastMessage]?.files?.file_name || null,
                fileUrl: chatMessages[indexOfLastMessage]?.files?.file_url || null,
                thumbUrl: chatMessages[indexOfLastMessage]?.files?.file_name || null,
                mimeType: chatMessages[indexOfLastMessage]?.files?.mime_type || null,
              }
            : null,
          private: chatMessages[indexOfLastMessage]?.private,
        };

        data[chatPos] = { ...data[chatPos], lastMessage };

        messageOperator = {
          ...state.messageOperator,
          chats: {
            ...chats,
            data,
          },
        };
      }

      state = {
        ...state,
        messageOperator,
        messageConsumer: {
          ...state?.messageConsumer,
          data: null,
          messages: {
            ...state?.messageConsumer?.messages,
            [action.payload.id]: chatMessages,
          },
          status: {
            ...state?.messageConsumer?.status,
            get_messages: {
              error: false,
              loading: false,
              success: {
                status: true,
                chatId: action.payload.id,
              },
            },
          },
        },
      };
      break;
    }
    case GET_MESSAGE:
      state = {
        ...state,
        messageOperator: {
          ...state.messageOperator,
          status: {
            ...state.messageOperator.status,
            get_message: {
              error: false,
              loading: true,
              success: false,
            },
          },
        },
      };
      break;
    case SET_MESSAGES:
      state = {
        ...state,
        messageOperator: {
          ...state.messageOperator,
          chats: {
            ...state.messageOperator.chats,
            ...action.payload,
          },
          status: {
            ...state.messageOperator.status,
            get_messages: {
              error: false,
              loading: false,
              success: true,
            },
          },
        },
      };
      break;
    case SET_MESSAGE:
      state = {
        ...state,
        messageOperator: {
          ...state.messageOperator,
          chats: {
            ...state.messageOperator.chats,
            ...action.payload,
          },
          status: {
            ...state.messageOperator.status,
            get_message: {
              error: false,
              loading: false,
              success: true,
            },
          },
        },
      };
      break;
    case SET_AI_MESSAGE: 
      const conversationIndex = state?.messageOperator?.chats?.data?.findIndex(conversation => conversation.conversationId === action.payload.conversationId);
      if (conversationIndex < 0) {
        state = { ...state };
        break;
      }

      const messageIndex = state?.messageOperator?.chats?.data[conversationIndex]?.message?.findIndex(message => message.currentId === action.payload.messageId);
      if (messageIndex < 0) {
        state = { ...state };
        break;
      }

      state.messageOperator.chats.data[conversationIndex].message[messageIndex] = {
        ...state.messageOperator.chats.data[conversationIndex].message[messageIndex],
        ...action.payload.message
      }

      state = {
        ...state,
        messageOperator: {
          ...state.messageOperator,
          chats: {
            ...state.messageOperator.chats,
            ...action.payload,
          },
        },
      }
      break;
    case START_OBSERVER:
      state = {
        ...state,
        messageOperator: {
          ...state.messageOperator,
          data: action.payload,
          status: {
            ...state.messageOperator.status,
            get_messages: {
              error: false,
              loading: true,
              success: false,
            },
          },
        },
      };
      break;
    case STARTED_OBSERVER:
      state = {
        ...state,
        messageOperator: {
          ...state.messageOperator,
          chats: {
            ...state.messageOperator.chats,
            ...action.payload,
          },
          status: {
            ...state.messageOperator.status,
            get_messages: {
              error: false,
              loading: false,
              success: true,
            },
          },
        },
      };
      break;
    case SEND_MESSAGE:
      state = {
        ...state,
        messageOperator: {
          ...state.messageOperator,
          data: action.payload,
          status: {
            ...state.messageOperator.status,
            send_message: {
              error: false,
              loading: true,
              success: false,
            },
          },
        },
      };
      break;
    case SENT_MESSAGE:
      state = {
        ...state,
        messageOperator: {
          ...state.messageOperator,
          data: {},
          status: {
            ...state.messageOperator.status,
            send_message: {
              error: false,
              loading: false,
              success: {
                status: {
                  sending: false,
                  sent: true,
                  delivered: null,
                  read: null,
                  error: null,
                },
                message: action.payload.message,
                chatId: action.payload.chatId,
                previousId: action.payload.previousId,
                currentId: action.payload.currentId,
                sendTime: action.payload.sendTime,
                sentTime: action.payload.sentTime,
                files: action.payload?.files,
              },
            },
          },
        },
      };
      break;
    case UPLOAD_FILE:
      state = {
        ...state,
        messageOperator: {
          ...state.messageOperator,
          data: action.payload,
          status: {
            ...state.messageOperator.status,
            upload_file: {
              error: false,
              loading: true,
              success: false,
            },
          },
        },
      };
      break;
    case UPLOADED_FILE:
      state = {
        ...state,
        messageOperator: {
          ...state.messageOperator,
          data: {},
          status: {
            ...state.messageOperator.status,
            upload_file: {
              error: false,
              loading: false,
              success: {
                status: true,
                fileId: action.payload?.fileId,
                sendTime: action.payload?.sendTime,
              },
            },
          },
        },
      };
      break;
    case REMOVE_MESSAGE:
      let auxData = state?.messageOperator?.chats?.data;
      let posUnread = auxData[action?.payload?.data?.pos]?.message?.findIndex(
        (e) => e.hasOwnProperty("unreadMsg")
      );

      if (posUnread > -1) {
        auxData[action?.payload?.data?.pos].message.splice(posUnread, 1);
      }
      state = {
        ...state,
        messageOperator: {
          ...state.messageOperator,
          chats: {
            ...state.messageOperator.chats,
            data: auxData,
          },
        },
      };
      break;
    case UPDATE_UNREAD_MSG:
      let auxUpdate = state?.messageOperator?.chats?.data;
      auxUpdate[action?.payload?.data?.pos].unreadMessages =
        action?.payload?.data?.unreadMessages;
      state = {
        ...state,
        messageOperator: {
          ...state.messageOperator,
          chats: {
            ...state.messageOperator.chats,
            data: auxUpdate,
          },
        },
      };
      break;
    case JOIN_CONVERSATION:
      state = {
        ...state,
        messageOperator: {
          ...state.messageOperator,
          data: action.payload,
          status: {
            ...state.messageOperator.status,
            join_conversation: {
              error: false,
              loading: true,
              success: false,
            },
          },
        },
      };
      break;
    case JOINED_CONVERSATION:
      state = {
        ...state,
        messageOperator: {
          ...state.messageOperator,
          status: {
            ...state.messageOperator.status,
            join_conversation: {
              error: false,
              loading: false,
              success: true,
            },
          },
        },
      };
      break;
    case SAVE_MESSAGE:
      state = {
        ...state,
        messageOperator: {
          ...state.messageOperator,
          chats_scroll_text: {
            ...state.messageOperator.chats_scroll_text,
            [action.payload.id]: {
              ...state.messageOperator.chats_scroll_text?.[action.payload.id],
              textInput: action.payload.message,
            },
          },
        },
      };
      break;

    case SAVE_SCROLL:
      state = {
        ...state,
        messageOperator: {
          ...state.messageOperator,
          chats_scroll_text: {
            ...state.messageOperator.chats_scroll_text,
            [action.payload.id]: {
              ...state.messageOperator.chats_scroll_text?.[action.payload.id],
              scrollPos: action.payload.scroll,
            },
          },
        },
      };
      break;

    case GET_SKILLS_ATTENDANCE:
      state = {
        ...state,
        createAttendance: {
          ...state.createAttendance,
          status: {
            ...state.createAttendance.status,
            get_skills_attendance: {
              error: false,
              loading: true,
              success: false,
            },
          },
        },
      };
      break;

    case SET_SKILLS_ATTENDANCE:
      state = {
        ...state,
        createAttendance: {
          ...state.createAttendance,
          data: action.payload.error ? [] : action.payload.data,
          status: {
            ...state.createAttendance.status,
            get_skills_attendance: {
              error: action.payload.error,
              loading: false,
              success: action.payload.error ? false : true,
            },
          },
        },
      };
      break;

    case CREATE_ATTENDANCE:
      state = {
        ...state,
        createAttendance: {
          ...state.createAttendance,
          status: {
            ...state.createAttendance.status,
            create_attendance: {
              error: false,
              loading: true,
              success: false,
            },
          },
        },
      };
      break;

    case CREATED_ATTENDANCE:
      state = {
        ...state,
        createAttendance: {
          ...state.createAttendance,
          status: {
            ...state.createAttendance.status,
            create_attendance: {
              error: action.payload.error,
              loading: false,
              success: action.payload.error ? false : true,
            },
          },
        },
      };
      break;

    

    case REMOVE_SCROLL_MESSAGE:
      let { [action.payload.id]: id, ...rest } =
        state?.messageOperator?.chats_scroll_text ?? {};

      state = {
        ...state,
        messageOperator: {
          ...state.messageOperator,
          chats_scroll_text: {
            ...rest,
          },
        },
      };
      break;

    case CREATE_COMMENTARY:
      state = {
        ...state,
        commentary: {
          success: false,
          loading: true,
          error: false,
        },
      };
      break;

    case CREATE_COMMENTARY_SUCCESS:
      state = {
        ...state,
        commentary: {
          success: true,
          loading: false,
          error: false,
        },
      };
      break;

    case CREATE_COMMENTARY_FAILURE:
      state = {
        ...state,
        commentary: {
          success: false,
          loading: false,
          error: true,
        },
      };
      break;

    case DELETE_COMMENTARY:
      state = {
        ...state,
        deleteCommentary: {
          success: false,
          loading: true,
          error: false,
        },
      };
      break;

    case DELETE_COMMENTARY_SUCCESS:
      state = {
        ...state,
        deleteCommentary: {
          success: true,
          loading: false,
          error: false,
        },
      };
      break;

    case DELETE_COMMENTARY_FAILURE:
      state = {
        ...state,
        deleteCommentary: {
          success: false,
          loading: false,
          error: true,
        },
      };
      break;

    default:
      // do nothing
      break;
  }
  return state;
};

export default Operator;
